export * from './types';

import getPayoutSchema from './getPayoutSchema';
import getSignupSchema from './getSignupSchema';
import getSocialSchema from './getSocialSchema';
import getTaxRecordSchema from './getTaxRecordSchema';
import getTaxSchema from './getTaxSchema';

export {getPayoutSchema, getSignupSchema, getSocialSchema, getTaxRecordSchema, getTaxSchema};

const getInfluencerSchema = (getMessage, messages) => ({
    payoutSchema: () => getPayoutSchema(getMessage, messages),
    signupSchema: () => getSignupSchema(getMessage, messages),
    socialSchema: () => getSocialSchema(getMessage, messages),
    taxRecordSchema: () => getTaxRecordSchema(getMessage, messages),
    taxSchema: () => getTaxSchema(getMessage, messages)
});

export default getInfluencerSchema;
